import { render, staticRenderFns } from "./RateUser.vue?vue&type=template&id=2979a950&scoped=true&"
import script from "./RateUser.vue?vue&type=script&lang=js&"
export * from "./RateUser.vue?vue&type=script&lang=js&"
import style0 from "./RateUser.vue?vue&type=style&index=0&id=2979a950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2979a950",
  null
  
)

export default component.exports